import { PageContentStateContext } from '@src/contexts/wysiwyg/page_content';
import { useContext } from 'react';

function usePageContentItemCount() {
  const { contentItems } = useContext(PageContentStateContext);

  return contentItems.length;
}

export default usePageContentItemCount;
